import SessionTypeVisualizeVocabularies from 'frontend/components/school/session-type-visualize-vocabularies';
<template><SessionTypeVisualizeVocabularies @model={{@model}} /></template>
